import { createWebHistory, createRouter } from "vue-router";
import CalcolatriceMedica from "@/views/calcolatriceMedica/CalcolatriceMedica";
import RegistroPage from "@/views/Registro/RegistroPage.vue";
import CentriConvenzionati from "@/views/CentriConvenzionati.vue";
import ReportPage from "@/views/Report/ReportPage.vue";
import AltroPage from "@/views/Altro/AltroPage.vue";
import SchedaPaziente from "@/views/schedaPaziente/SchedaPaziente.vue";
import TaccuinoPage from "@/views/Taccuino/TaccuinoPage.vue";
import TaccuinoDetailsPage from "@/views/Taccuino/taccuinoDetails.vue";
import Esami from "@/views/Esami/EsamiPage.vue";

import FarmaciPage from "@/views/Farmaci/FarmaciPage.vue";
import FileDispositiviPage from "../views/fileedispositivi/fileDispositiviPage.vue";
//import DottoriPage from "../views/Registro/DottoriPage.vue";
import DottoriPage from "../views/dottori/dottoriPage.vue";
import DiagnosiPage from "../views/Diagnosi/DiagnosiPage.vue";
import VisitePage from "../views/Visite/VisitePage.vue";
import EsamiPage from "../views/EsamiPage.vue";
import AuthenticateUser from "@/views/authentication/AuthenticateUser.vue";
import AnamnesiPage from "../views/Anamnesi/AnamnesiPage.vue";
import VaccinazioniPage from "../views/Vaccinazioni/VaccinazioniPage.vue";
import PaypalPage from "../views/Paypal/PaypalPage.vue";
import RegistroAccessi from "../views/Accessi/RegistroAccessi.vue";
import HasBledScore from "../views/calcolatriceMedica/CalcoloScoresSection/HasBledScore.vue";
import MeldScore from "../views/calcolatriceMedica/CalcoloScoresSection/MeldScore.vue";
import ChaDsVasScore from "../views/calcolatriceMedica/CalcoloScoresSection/ChaDsVasScore.vue";
import FraminghamRiskScore from "../views/calcolatriceMedica/CalcoloScoresSection/FraminghamRiskScore.vue";
import CardiovascolareScore from "../views/calcolatriceMedica/CalcoloScoresSection/CardiovascolareScore.vue";
import AccountPage from "@/views/Account/AccountPage.vue";
import CookiePolicy from "@/views/Account/CookiePolicy.vue";
import Model3d from "../components/Model3D.vue";
import Consensi from "@/views/Account/Consensi.vue";
import admin from "@/views/admin/admin.vue"
import funzionalita from "@/views/admin/funzionalita.vue";
import ruoli from "@/views/admin/ruoli.vue"
import licenze from "@/views/admin/licenze.vue"
const routes = [
  {
    path: "/",
    component: RegistroPage,
    name: "Home",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Registro/SchedaPaziente",
    component: SchedaPaziente,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/admin/admin",
    component: admin,
  },
   {
    path: "/admin/funzionalita",
    component: funzionalita,
  },
   {
    path: "/admin/ruoli",
    component: ruoli,
  },
    {
    path: "/admin/licenze",
    component: licenze,
  },
   
  {
    path: "/Registro",
    name: "RegistroPage",
    component: RegistroPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Registro/Paypal",
    name: "PaypalPage",
    component: PaypalPage,
    meta: {
      requiresAuth: true,
    },
  },


    {
        path: "/Registro/Accessi",
        name: "Accessi",
        component: RegistroAccessi
    },

  {
    path: "/Registro/Taccuino",
    component: TaccuinoPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Registro/Taccuino/:id",
    name: "TaccuinoId",
    component: TaccuinoDetailsPage,
    props: true,
  },
  {
    path: "/Registro/Vaccini",
    component: VaccinazioniPage,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/centriConvezionati/CentriConvezionati",
    name: "CentriConvenzionati",
    component: CentriConvenzionati,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/calcolatricemedica/Dosi",
    name: "CalcolatriceMedicaD",
    component: CalcolatriceMedica,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/calcolatricemedica/Clearance",
    name: "CalcolatriceMedicaC",
    component: CalcolatriceMedica,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/calcolatricemedica/calcoloScores",
    name: "CalcolatriceMedicaS",
    component: CalcolatriceMedica,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/calcolatricemedica/calcoloScores/hasBledScore",
    name: "CalcolatriceMedicaShasBledScore",
    component: HasBledScore,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/calcolatricemedica/calcoloScores/meldScore",
    name: "CalcolatriceMedicaSmeldScore",
    component: MeldScore,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/calcolatricemedica/calcoloScores/chaDsVasScore",
    name: "CalcolatriceMedicaSchaDsScore",
    component: ChaDsVasScore,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/calcolatricemedica/calcoloScores/framinghamScore",
    name: "CalcolatriceMedicaSframinghamscore",
    component: FraminghamRiskScore,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/calcolatricemedica/calcoloScores/cardiovascolareScore",
    name: "CalcolatriceMedicaScardiovascolarescore",
    component: CardiovascolareScore,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/report",
    name: "ReportPage",
    component: ReportPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/altro",
    name: "AltroPage",
    component: AltroPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Taccuino",
    name: "Taccuino",
    component: TaccuinoPage,
  },
  {
    path: "/Registro/Diagnosi",
    name: "Diagnosi",
    component: DiagnosiPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Registro/Visite",
    name: "Visite",
    component: VisitePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Registro/Farmaci",
    name: "FarmaciPage",
    component: FarmaciPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Registro/File",
    name: "File",
    component: FileDispositiviPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Registro/Dottori",
    name: "Dottori",
    component: DottoriPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Registro/Esami",
    name: "Esami",
    component: Esami,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: AuthenticateUser,
  },
  {
    path: "/Registro/Anamnesi",
    name: "Anamnesi",
    component: AnamnesiPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/account",
    name: "Account",
    component: AccountPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/account/CookiePolicy",
    name: "CookiePolicy",
    component: CookiePolicy,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/model/model3d",
    name: "Model3d",
    component: Model3d,
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: "/account/Consensi",
    name: "Consensi",
    component: Consensi,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/register",
  //   name: "Register",
  //   component: AuthenticateUser,
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
